import LegalPage, { H3, P, List } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalPage
      kicker="Privacy Policy"
      title="How we handle your information."
      effectiveDate="February 2026"
    >
      <P>
        Maven Skies Inc. (&ldquo;Maven Skies,&rdquo; &ldquo;we,&rdquo; &ldquo;us&rdquo;) respects your privacy.
        This Policy explains how we collect, use, and safeguard information
        submitted through this website and our related programs, including
        Maven Skies Angels and Groundwork. By using this site or submitting an
        invitation request, you agree to this Policy.
      </P>

      <H3>Information we collect</H3>
      <List
        items={[
          "Information you provide directly: your name, email, professional role, and any details you share in an invitation request or email.",
          "Information collected automatically: basic technical logs such as IP address, browser, device type, and pages visited, used to keep the site secure and functional.",
          "Cookies: we use a minimal set of cookies strictly necessary for the site to operate. We do not use advertising or tracking cookies.",
        ]}
      />

      <H3>How we use your information</H3>
      <List
        items={[
          "To respond to invitation requests and correspondence.",
          "To assess suitability for Maven Skies Angels, Groundwork, and related programs.",
          "To send updates about programs, events, or opportunities you have expressed interest in. You may opt out at any time.",
          "To operate, secure, and improve this website.",
          "To comply with applicable laws.",
        ]}
      />

      <H3>How we share your information</H3>
      <P>
        We do not sell your information. We share it only with trusted service
        providers who help us operate the site and its programs (for example,
        email hosting), and with program partners where you have specifically
        engaged with a joint offering (for example, Groundwork is delivered in
        partnership with Capital M Ventures and the CVCA). We may also disclose
        information where required by law.
      </P>

      <H3>Data retention</H3>
      <P>
        We retain information for as long as reasonably necessary to fulfil the
        purposes described above, or as required by law. Invitation requests
        and correspondence are typically kept for the duration of our
        relationship, plus a reasonable archival period.
      </P>

      <H3>Your rights</H3>
      <P>
        You may request access to, correction of, or deletion of your personal
        information at any time by emailing{" "}
        <a className="underline" style={{ color: "#e9d6a2" }} href="mailto:danielle@mavenskies.ca">
          danielle@mavenskies.ca
        </a>
        . We respond to verified requests within a reasonable time and in
        accordance with the Personal Information Protection and Electronic
        Documents Act (PIPEDA) and applicable provincial privacy laws.
      </P>

      <H3>Security</H3>
      <P>
        We take reasonable steps to protect your information using appropriate
        technical and organizational measures. No method of transmission over
        the internet is entirely secure; if you have concerns about a specific
        disclosure, please contact us.
      </P>

      <H3>International transfers</H3>
      <P>
        Some of our service providers may store or process information outside
        of Canada. Where that occurs, we ensure comparable protections apply.
      </P>

      <H3>Children</H3>
      <P>
        This site and its programs are directed at adults. We do not knowingly
        collect information from anyone under the age of majority in their
        province of residence.
      </P>

      <H3>Changes to this Policy</H3>
      <P>
        We may update this Policy from time to time. Material changes will be
        noted here with a revised effective date.
      </P>

      <H3>Contact</H3>
      <P>
        Questions or requests may be directed to{" "}
        <a className="underline" style={{ color: "#e9d6a2" }} href="mailto:danielle@mavenskies.ca">
          danielle@mavenskies.ca
        </a>
        , Maven Skies Inc., Saskatchewan, Canada.
      </P>
    </LegalPage>
  );
}
